import { useTypedLocation } from "src/utils/hooks/useTypedLocation";
import { getRouteIndexFromHash } from "src/utils/location/routeIndexFromHash";
import { useTripSearchResponse } from "./useTripSearchResponse";

export function useTripRouteIndex(): number | undefined {
  const { tripSearchResponse } = useTripSearchResponse();
  const location = useTypedLocation();
  const index = getRouteIndexFromHash(location.hash, tripSearchResponse);
  return index !== undefined && index >= 0 ? index : undefined;
}
